/**
 * Project management — client-side
 * Uses cookies to persist selected project across sessions.
 */

export interface Project {
  id: string;
  name: string;
  slug: string;
  description?: string;
  is_active: boolean;
  organization_id?: number;
  created_at: string;
}

const COOKIE_NAME = "social_project_id";

export function getCurrentProjectId(): string {
  if (typeof document === "undefined") return "";
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${COOKIE_NAME}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : "";
}

export function setProjectCookie(projectId: string): void {
  document.cookie = `${COOKIE_NAME}=${projectId}; path=/; max-age=${30 * 24 * 60 * 60}; SameSite=Lax`;
  fetch("/api/project/switch", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ project_id: projectId }),
  }).catch(() => {});
}

export async function switchProject(projectId: string): Promise<void> {
  await fetch("/api/project/switch", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ project_id: projectId }),
  });
  window.location.reload();
}
